import instance from './instance';

export const getAsanaData = () => instance.get(`/api/v0/asana/get_data`);

export const searchTasks = async ({ workspaceGid, query }) =>
  instance.get(`/api/v0/asana/search_tasks?workspaceGid=${workspaceGid}&query=${query}`);
